function calculateLength() {
  const limit = window.qr_code_limit
  const prefix_length = window.qr_prefix_length
  const progressBar = jQuery('.ucard__fields-progress .progress-bar')

  const fieldsString = jQuery('#user_card_fields').val()
  const fields = fieldsString.length > 0 ? fieldsString.split(',') : []
  let chars = prefix_length // { and } characters

  fields.forEach( f => {
    if (fields_weight[f])
      chars += fields_weight[f]
  })

  chars -=1 // remove trailing comma
  const percentage = parseInt(chars / limit * 100, 10)
  console.log(`Total characted used: ${chars} (${percentage}%)`)
  progressBar.attr('style', `width: ${percentage}%`)
  progressBar.html(`${percentage}% (${chars}/${limit})`)
}

jQuery(document).ready(function() {

  if (jQuery('#user_card_fields').length == 0)
    return;

  // hidden by default
  jQuery('#acceptance_disclaimer').hide();

  const str = jQuery('#user_card_fields').val();
  const _f = str.length > 0 ? str.split(',') : [];
  window.original_fields = _f.sort();
  console.log(`Initial fields: ${JSON.stringify(window.original_fields)}`)

  jQuery('#select_all').on('change', function() {
    jQuery('#select_all').data('selected', jQuery(this).data('selected') == 'true' ? 'false' : 'true')
    jQuery('.ucard-form .ucard__field').prop("checked", jQuery(this).data('selected') == 'true').trigger('change');
  });

  jQuery('.ucard-form .ucard__field').on('change', function() {
    const fieldsString = jQuery('#user_card_fields').val()
    const fields = fieldsString.length > 0 ? fieldsString.split(',') : []
    const fieldName = jQuery(this).attr('name')
    // console.log(`Field ${fieldName} - checked: ${jQuery(this).is(":checked")}`)
    if (jQuery(this).is(":checked") && fields.indexOf(fieldName) == -1) {
      fields.push(fieldName)
    } else if (!jQuery(this).is(":checked") && fields.indexOf(fieldName) > -1) {
      const idx = fields.indexOf(fieldName)
      fields.splice(idx, 1)
    }
    console.log(fields);
    jQuery('#user_card_fields').val(fields.join(','));

    if (fields.sort().map(el => window.original_fields.includes(el)).reduce((res, cur) => res && cur, true) && fields.length == window.original_fields.length) { // hide disclaimer
      jQuery('#acceptance_disclaimer').hide();
      jQuery('#accept_change').prop('required', false)
      jQuery('#qr_submit').prop('value', jQuery('#qr_submit').data('noChangeTitle'));

    } else { // show disclaimer and mark it required
      jQuery('#acceptance_disclaimer').show();
      jQuery('#accept_change').prop('required', true);
      jQuery('#qr_submit').prop('value', jQuery('#qr_submit').data('defaultTitle'));
    }

    calculateLength();
  })
  if (jQuery('#user_card_fields').length)
    calculateLength();
});